import React, {
  ClassAttributes,
  ForwardedRef,
  forwardRef,
  InputHTMLAttributes,
  useEffect,
  useState,
} from 'react';
import { Interpolation, Theme } from '@emotion/react';
import { wrap } from './style/default';
import { labelWrap, maxWrap } from './style/max';

interface Props
  extends InputHTMLAttributes<HTMLInputElement>,
    ClassAttributes<HTMLInputElement> {
  css?: Interpolation<Theme>;
  maxLength: number;
}

function MaxInput(
  {
    css,
    maxLength,
    value: propValue,
    onChange: propHandleChange,
    ...props
  }: Props,
  ref: ForwardedRef<HTMLInputElement>,
) {
  const [value, setValue] = useState('');

  useEffect(() => {
    propValue !== undefined && setValue(propValue as string);
  }, [propValue]);

  const handleChage = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (value.length > maxLength) return;
    setValue(e.target.value);
    propHandleChange?.(e);
  };

  return (
    <label css={labelWrap}>
      <input
        {...props}
        css={[wrap, css]}
        value={value}
        onChange={handleChage}
        ref={ref}
      />
      <div css={maxWrap}>
        <p>
          {value.length}
          <span>{`/${maxLength}자`}</span>
        </p>
      </div>
    </label>
  );
}

export default forwardRef(MaxInput);
